import { render, staticRenderFns } from "./VerifyCodeInputPage.vue?vue&type=template&id=b89cbd2c&scoped=true&"
import script from "./VerifyCodeInputPage.vue?vue&type=script&lang=js&"
export * from "./VerifyCodeInputPage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCodeInputPage.vue?vue&type=style&index=0&id=b89cbd2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89cbd2c",
  null
  
)

export default component.exports